export class SDKError extends Error {
    name;
    requestId;
    constructor(name, msg, requestId) {
        super(msg);
        this.requestId = requestId;
        this.name = name;
    }
}
/**
 *
 * @export
 * @class NetworkError
 * @extends {SDKError}
 */
export class NetworkError extends SDKError {
    constructor(msg, requestId) {
        super("NetworkError", msg, requestId);
    }
}
/**
 *
 * @export
 * @class TimeoutError
 * @extends {SDKError}
 */
export class TimeoutError extends SDKError {
    constructor(msg, requestId) {
        super("TimeoutError", msg, requestId);
    }
}
/**
 *
 * @export
 * @class BadRequestError
 * @extends {SDKError}
 */
export class BadRequestError extends SDKError {
    constructor(msg, requestId) {
        super("BadRequestError", msg, requestId);
    }
}
/**
 *
 * @export
 * @class AuthError
 * @extends {SDKError}
 */
export class AuthError extends SDKError {
    constructor(msg, requestId) {
        super("AuthError", msg, requestId);
    }
}
/**
 *
 * @export
 * @class ForbiddenError
 * @extends {SDKError}
 */
export class ForbiddenError extends SDKError {
    constructor(msg, requestId) {
        super("ForbiddenError", msg, requestId);
    }
}
/**
 *
 * @export
 * @class NotFoundError
 * @extends {SDKError}
 */
export class NotFoundError extends SDKError {
    constructor(msg, requestId) {
        super("NotFoundError", msg, requestId);
    }
}
/**
 *
 * @export
 * @class ServerError
 * @extends {SDKError}
 */
export class ServerError extends SDKError {
    constructor(msg, requestId) {
        super("ServerError", msg, requestId);
    }
}
/**
 *
 * @export
 * @class UnknownError
 * @extends {SDKError}
 */
export class UnknownError extends SDKError {
    constructor(msg, requestId) {
        super("UnknownError", msg, requestId);
    }
}
/**
 *
 * @export
 * @class AbortError
 * @extends {SDKError}
 */
export class AbortError extends SDKError {
    constructor(msg, requestId) {
        super("AbortError", msg, requestId);
    }
}
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name = "RequiredError";
    constructor(_field, msg) {
        super(msg);
    }
}
/**
 *
 * @export
 * @class PreconditionFailedError
 * @extends {Error}
 */
export class PreconditionFailedError extends Error {
    name = "PreconditionFailedError";
    constructor(_field, msg) {
        super(msg);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3JzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2Vycm9ycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHQSxNQUFNLE9BQU8sUUFBUyxTQUFRLEtBQUs7SUFDakMsSUFBSSxDQUFTO0lBRWIsU0FBUyxDQUFpQjtJQUUxQixZQUFZLElBQVksRUFBRSxHQUFZLEVBQUUsU0FBeUI7UUFDL0QsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBQ1gsSUFBSSxDQUFDLFNBQVMsR0FBRyxTQUFTLENBQUM7UUFDM0IsSUFBSSxDQUFDLElBQUksR0FBRyxJQUFJLENBQUM7SUFDbkIsQ0FBQztDQUNGO0FBRUQ7Ozs7O0dBS0c7QUFDSCxNQUFNLE9BQU8sWUFBYSxTQUFRLFFBQVE7SUFDeEMsWUFBWSxHQUFZLEVBQUUsU0FBeUI7UUFDakQsS0FBSyxDQUFDLGNBQWMsRUFBRSxHQUFHLEVBQUUsU0FBUyxDQUFDLENBQUM7SUFDeEMsQ0FBQztDQUNGO0FBRUQ7Ozs7O0dBS0c7QUFDSCxNQUFNLE9BQU8sWUFBYSxTQUFRLFFBQVE7SUFDeEMsWUFBWSxHQUFZLEVBQUUsU0FBeUI7UUFDakQsS0FBSyxDQUFDLGNBQWMsRUFBRSxHQUFHLEVBQUUsU0FBUyxDQUFDLENBQUM7SUFDeEMsQ0FBQztDQUNGO0FBRUQ7Ozs7O0dBS0c7QUFDSCxNQUFNLE9BQU8sZUFBZ0IsU0FBUSxRQUFRO0lBQzNDLFlBQVksR0FBWSxFQUFFLFNBQXlCO1FBQ2pELEtBQUssQ0FBQyxpQkFBaUIsRUFBRSxHQUFHLEVBQUUsU0FBUyxDQUFDLENBQUM7SUFDM0MsQ0FBQztDQUNGO0FBRUQ7Ozs7O0dBS0c7QUFDSCxNQUFNLE9BQU8sU0FBVSxTQUFRLFFBQVE7SUFDckMsWUFBWSxHQUFZLEVBQUUsU0FBeUI7UUFDakQsS0FBSyxDQUFDLFdBQVcsRUFBRSxHQUFHLEVBQUUsU0FBUyxDQUFDLENBQUM7SUFDckMsQ0FBQztDQUNGO0FBRUQ7Ozs7O0dBS0c7QUFDSCxNQUFNLE9BQU8sY0FBZSxTQUFRLFFBQVE7SUFDMUMsWUFBWSxHQUFZLEVBQUUsU0FBeUI7UUFDakQsS0FBSyxDQUFDLGdCQUFnQixFQUFFLEdBQUcsRUFBRSxTQUFTLENBQUMsQ0FBQztJQUMxQyxDQUFDO0NBQ0Y7QUFFRDs7Ozs7R0FLRztBQUNILE1BQU0sT0FBTyxhQUFjLFNBQVEsUUFBUTtJQUN6QyxZQUFZLEdBQVksRUFBRSxTQUF5QjtRQUNqRCxLQUFLLENBQUMsZUFBZSxFQUFFLEdBQUcsRUFBRSxTQUFTLENBQUMsQ0FBQztJQUN6QyxDQUFDO0NBQ0Y7QUFFRDs7Ozs7R0FLRztBQUNILE1BQU0sT0FBTyxXQUFZLFNBQVEsUUFBUTtJQUN2QyxZQUFZLEdBQVksRUFBRSxTQUF5QjtRQUNqRCxLQUFLLENBQUMsYUFBYSxFQUFFLEdBQUcsRUFBRSxTQUFTLENBQUMsQ0FBQztJQUN2QyxDQUFDO0NBQ0Y7QUFFRDs7Ozs7R0FLRztBQUNILE1BQU0sT0FBTyxZQUFhLFNBQVEsUUFBUTtJQUN4QyxZQUFZLEdBQVksRUFBRSxTQUF5QjtRQUNqRCxLQUFLLENBQUMsY0FBYyxFQUFFLEdBQUcsRUFBRSxTQUFTLENBQUMsQ0FBQztJQUN4QyxDQUFDO0NBQ0Y7QUFFRDs7Ozs7R0FLRztBQUNILE1BQU0sT0FBTyxVQUFXLFNBQVEsUUFBUTtJQUN0QyxZQUFZLEdBQVksRUFBRSxTQUF5QjtRQUNqRCxLQUFLLENBQUMsWUFBWSxFQUFFLEdBQUcsRUFBRSxTQUFTLENBQUMsQ0FBQztJQUN0QyxDQUFDO0NBQ0Y7QUFFRDs7Ozs7R0FLRztBQUNILE1BQU0sT0FBTyxhQUFjLFNBQVEsS0FBSztJQUN0QyxJQUFJLEdBQUcsZUFBZSxDQUFDO0lBRXZCLFlBQVksTUFBYyxFQUFFLEdBQVk7UUFDdEMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDO0lBQ2IsQ0FBQztDQUNGO0FBRUQ7Ozs7O0dBS0c7QUFDSCxNQUFNLE9BQU8sdUJBQXdCLFNBQVEsS0FBSztJQUNoRCxJQUFJLEdBQUcseUJBQXlCLENBQUM7SUFFakMsWUFBWSxNQUFjLEVBQUUsR0FBWTtRQUN0QyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUM7SUFDYixDQUFDO0NBQ0YiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBlc2xpbnQtZGlzYWJsZS1uZXh0LWxpbmUgbWF4LWNsYXNzZXMtcGVyLWZpbGVcbmltcG9ydCB7IHJlcXVlc3RJZFR5cGUgfSBmcm9tIFwiLi90eXBlc1wiO1xuXG5leHBvcnQgY2xhc3MgU0RLRXJyb3IgZXh0ZW5kcyBFcnJvciB7XG4gIG5hbWU6IHN0cmluZztcblxuICByZXF1ZXN0SWQ/OiByZXF1ZXN0SWRUeXBlO1xuXG4gIGNvbnN0cnVjdG9yKG5hbWU6IHN0cmluZywgbXNnPzogc3RyaW5nLCByZXF1ZXN0SWQ/OiByZXF1ZXN0SWRUeXBlKSB7XG4gICAgc3VwZXIobXNnKTtcbiAgICB0aGlzLnJlcXVlc3RJZCA9IHJlcXVlc3RJZDtcbiAgICB0aGlzLm5hbWUgPSBuYW1lO1xuICB9XG59XG5cbi8qKlxuICpcbiAqIEBleHBvcnRcbiAqIEBjbGFzcyBOZXR3b3JrRXJyb3JcbiAqIEBleHRlbmRzIHtTREtFcnJvcn1cbiAqL1xuZXhwb3J0IGNsYXNzIE5ldHdvcmtFcnJvciBleHRlbmRzIFNES0Vycm9yIHtcbiAgY29uc3RydWN0b3IobXNnPzogc3RyaW5nLCByZXF1ZXN0SWQ/OiByZXF1ZXN0SWRUeXBlKSB7XG4gICAgc3VwZXIoXCJOZXR3b3JrRXJyb3JcIiwgbXNnLCByZXF1ZXN0SWQpO1xuICB9XG59XG5cbi8qKlxuICpcbiAqIEBleHBvcnRcbiAqIEBjbGFzcyBUaW1lb3V0RXJyb3JcbiAqIEBleHRlbmRzIHtTREtFcnJvcn1cbiAqL1xuZXhwb3J0IGNsYXNzIFRpbWVvdXRFcnJvciBleHRlbmRzIFNES0Vycm9yIHtcbiAgY29uc3RydWN0b3IobXNnPzogc3RyaW5nLCByZXF1ZXN0SWQ/OiByZXF1ZXN0SWRUeXBlKSB7XG4gICAgc3VwZXIoXCJUaW1lb3V0RXJyb3JcIiwgbXNnLCByZXF1ZXN0SWQpO1xuICB9XG59XG5cbi8qKlxuICpcbiAqIEBleHBvcnRcbiAqIEBjbGFzcyBCYWRSZXF1ZXN0RXJyb3JcbiAqIEBleHRlbmRzIHtTREtFcnJvcn1cbiAqL1xuZXhwb3J0IGNsYXNzIEJhZFJlcXVlc3RFcnJvciBleHRlbmRzIFNES0Vycm9yIHtcbiAgY29uc3RydWN0b3IobXNnPzogc3RyaW5nLCByZXF1ZXN0SWQ/OiByZXF1ZXN0SWRUeXBlKSB7XG4gICAgc3VwZXIoXCJCYWRSZXF1ZXN0RXJyb3JcIiwgbXNnLCByZXF1ZXN0SWQpO1xuICB9XG59XG5cbi8qKlxuICpcbiAqIEBleHBvcnRcbiAqIEBjbGFzcyBBdXRoRXJyb3JcbiAqIEBleHRlbmRzIHtTREtFcnJvcn1cbiAqL1xuZXhwb3J0IGNsYXNzIEF1dGhFcnJvciBleHRlbmRzIFNES0Vycm9yIHtcbiAgY29uc3RydWN0b3IobXNnPzogc3RyaW5nLCByZXF1ZXN0SWQ/OiByZXF1ZXN0SWRUeXBlKSB7XG4gICAgc3VwZXIoXCJBdXRoRXJyb3JcIiwgbXNnLCByZXF1ZXN0SWQpO1xuICB9XG59XG5cbi8qKlxuICpcbiAqIEBleHBvcnRcbiAqIEBjbGFzcyBGb3JiaWRkZW5FcnJvclxuICogQGV4dGVuZHMge1NES0Vycm9yfVxuICovXG5leHBvcnQgY2xhc3MgRm9yYmlkZGVuRXJyb3IgZXh0ZW5kcyBTREtFcnJvciB7XG4gIGNvbnN0cnVjdG9yKG1zZz86IHN0cmluZywgcmVxdWVzdElkPzogcmVxdWVzdElkVHlwZSkge1xuICAgIHN1cGVyKFwiRm9yYmlkZGVuRXJyb3JcIiwgbXNnLCByZXF1ZXN0SWQpO1xuICB9XG59XG5cbi8qKlxuICpcbiAqIEBleHBvcnRcbiAqIEBjbGFzcyBOb3RGb3VuZEVycm9yXG4gKiBAZXh0ZW5kcyB7U0RLRXJyb3J9XG4gKi9cbmV4cG9ydCBjbGFzcyBOb3RGb3VuZEVycm9yIGV4dGVuZHMgU0RLRXJyb3Ige1xuICBjb25zdHJ1Y3Rvcihtc2c/OiBzdHJpbmcsIHJlcXVlc3RJZD86IHJlcXVlc3RJZFR5cGUpIHtcbiAgICBzdXBlcihcIk5vdEZvdW5kRXJyb3JcIiwgbXNnLCByZXF1ZXN0SWQpO1xuICB9XG59XG5cbi8qKlxuICpcbiAqIEBleHBvcnRcbiAqIEBjbGFzcyBTZXJ2ZXJFcnJvclxuICogQGV4dGVuZHMge1NES0Vycm9yfVxuICovXG5leHBvcnQgY2xhc3MgU2VydmVyRXJyb3IgZXh0ZW5kcyBTREtFcnJvciB7XG4gIGNvbnN0cnVjdG9yKG1zZz86IHN0cmluZywgcmVxdWVzdElkPzogcmVxdWVzdElkVHlwZSkge1xuICAgIHN1cGVyKFwiU2VydmVyRXJyb3JcIiwgbXNnLCByZXF1ZXN0SWQpO1xuICB9XG59XG5cbi8qKlxuICpcbiAqIEBleHBvcnRcbiAqIEBjbGFzcyBVbmtub3duRXJyb3JcbiAqIEBleHRlbmRzIHtTREtFcnJvcn1cbiAqL1xuZXhwb3J0IGNsYXNzIFVua25vd25FcnJvciBleHRlbmRzIFNES0Vycm9yIHtcbiAgY29uc3RydWN0b3IobXNnPzogc3RyaW5nLCByZXF1ZXN0SWQ/OiByZXF1ZXN0SWRUeXBlKSB7XG4gICAgc3VwZXIoXCJVbmtub3duRXJyb3JcIiwgbXNnLCByZXF1ZXN0SWQpO1xuICB9XG59XG5cbi8qKlxuICpcbiAqIEBleHBvcnRcbiAqIEBjbGFzcyBBYm9ydEVycm9yXG4gKiBAZXh0ZW5kcyB7U0RLRXJyb3J9XG4gKi9cbmV4cG9ydCBjbGFzcyBBYm9ydEVycm9yIGV4dGVuZHMgU0RLRXJyb3Ige1xuICBjb25zdHJ1Y3Rvcihtc2c/OiBzdHJpbmcsIHJlcXVlc3RJZD86IHJlcXVlc3RJZFR5cGUpIHtcbiAgICBzdXBlcihcIkFib3J0RXJyb3JcIiwgbXNnLCByZXF1ZXN0SWQpO1xuICB9XG59XG5cbi8qKlxuICpcbiAqIEBleHBvcnRcbiAqIEBjbGFzcyBSZXF1aXJlZEVycm9yXG4gKiBAZXh0ZW5kcyB7RXJyb3J9XG4gKi9cbmV4cG9ydCBjbGFzcyBSZXF1aXJlZEVycm9yIGV4dGVuZHMgRXJyb3Ige1xuICBuYW1lID0gXCJSZXF1aXJlZEVycm9yXCI7XG5cbiAgY29uc3RydWN0b3IoX2ZpZWxkOiBzdHJpbmcsIG1zZz86IHN0cmluZykge1xuICAgIHN1cGVyKG1zZyk7XG4gIH1cbn1cblxuLyoqXG4gKlxuICogQGV4cG9ydFxuICogQGNsYXNzIFByZWNvbmRpdGlvbkZhaWxlZEVycm9yXG4gKiBAZXh0ZW5kcyB7RXJyb3J9XG4gKi9cbmV4cG9ydCBjbGFzcyBQcmVjb25kaXRpb25GYWlsZWRFcnJvciBleHRlbmRzIEVycm9yIHtcbiAgbmFtZSA9IFwiUHJlY29uZGl0aW9uRmFpbGVkRXJyb3JcIjtcblxuICBjb25zdHJ1Y3RvcihfZmllbGQ6IHN0cmluZywgbXNnPzogc3RyaW5nKSB7XG4gICAgc3VwZXIobXNnKTtcbiAgfVxufVxuIl19